import qs from 'qs'

import { BOOK_VIEWER_PARAMS } from 'utils/books'

type BuildBookChapterUrlParams = {
  originalBookId: string
  chapterOrder: number
  part?: number
}

type BuildBookSectionUrlParams = {
  originalBookId: string
  chapterOrder: number
  sectionPart?: number
  sectionId: string
}

export const buildBookChapterUrl = ({
  originalBookId,
  chapterOrder,
  part = 1
}: BuildBookChapterUrlParams): string => {
  const chapterPart = part > 0 ? part : 1

  return `/books/${originalBookId}/chapter/${chapterOrder}/part/${chapterPart}`
}

export const buildBookSectionUrl = ({
  originalBookId,
  chapterOrder,
  sectionPart,
  sectionId
}: BuildBookSectionUrlParams): string => {
  const part = sectionPart && sectionPart > 0 ? sectionPart : 1
  const query = qs.stringify(
    { [BOOK_VIEWER_PARAMS.sectionIdContext]: sectionId },
    { addQueryPrefix: true, encode: false }
  )

  return `${buildBookChapterUrl({ originalBookId, chapterOrder, part })}${query}`
}
